import React, { FunctionComponent } from 'react';
import DemoPages from './pages';
import type { RouteProps } from 'react-router';

const DemoSubapp: FunctionComponent<RouteProps> = (props) => {
  return <DemoPages />;
};

export default DemoSubapp;
